export const INCH_TO_FT = 1 / 12;
export const DEFAULT_VOXEL_SIZE_IN = 2;
export const DEFAULT_VOXEL_SIZE_FT = DEFAULT_VOXEL_SIZE_IN * INCH_TO_FT;
// A part min corner closer than this to a voxel boundary is moved just past it (see computeVoxelBoundaryNudge).
export const VOXEL_BOUNDARY_TOLERANCE_FT = 0.004;
export const VOXEL_BOUNDARY_NUDGE_FT = 0.001;

export const INTERSECTION_COLOR = 0xFF0000;
export const EDIT_ACTIVE_COLOR = 0x66FF33;
export const SUPPORT_PART_COLOR = 0xFFD700;
export const IDLE_PART_COLOR = 0xA9A9A9;

// Orientation steps are in-plane rotation increments around the vertical (Z) axis.
// In the C++ nesting algorithm (computeTransformsByMeshAndDir), placeLongestDirAlongX is true for all
// steel parts placed on the trailer, so elongated parts only have 2 yaw orientations (0° and 180°).
// Square parts (or pallets) have 4 yaw orientations (0°, 90°, 180°, 270°).
export const ORIENTATION_STEP_COUNT = 4;
export const ORIENTATION_STEP_ANGLE_DEG = 90;
export const ORIENTATION_STEP_COUNT_SQUARE = 4;
export const ORIENTATION_STEP_ANGLE_SQUARE_DEG = 90;
export const ORIENTATION_STEP_COUNT_LONG = 2;
export const ORIENTATION_STEP_ANGLE_LONG_DEG = 180;

export const COLLISION_CLEARANCE_FT = 0.02; // ~1/4 inch
export const REPLACEMENT_CLEARANCE_FT = 0;
export const TRAILER_BOX_NAME = 'Trailer Box';
